import React from "react";

const TableBody = ({ children }) => {
    return <tbody className="table__body">{children}</tbody>;
};

TableBody.propTypes = {};
TableBody.defaultProps = {};

export default TableBody;
